import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mock';
import { Menu, X, Globe } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const { language, toggleLanguage } = useLanguage();
  const t = content[language];
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo - Removed as per user request */}
          <div className="flex-shrink-0">
            {/* Logo removed */}
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              {t.nav.home}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              {t.nav.about}
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              {t.nav.services}
            </button>
            <button
              onClick={() => scrollToSection('why-us')}
              className={`text-sm font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              {t.nav.whyUs}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              {t.nav.contact}
            </button>

            {/* Language Toggle */}
            <button
              onClick={toggleLanguage}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-colors ${
                isScrolled
                  ? 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                  : 'bg-white/10 text-white hover:bg-white/20'
              }`}
            >
              <Globe className="w-4 h-4" />
              <span className="text-sm font-medium">{language === 'ar' ? 'EN' : 'AR'}</span>
            </button>

            <Button
              onClick={() => scrollToSection('consultation')}
              className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white px-6 py-2 shadow-lg hover:shadow-xl transition-all"
            >
              {t.nav.consultation}
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-3">
            <button
              onClick={toggleLanguage}
              className={`p-2 rounded-lg ${
                isScrolled
                  ? 'bg-slate-100 text-slate-700'
                  : 'bg-white/10 text-white'
              }`}
            >
              <Globe className="w-5 h-5" />
            </button>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2 rounded-lg ${
                isScrolled
                  ? 'bg-slate-100 text-slate-700'
                  : 'bg-white/10 text-white'
              }`}
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg border-t">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 rounded-lg transition-colors"
            >
              {t.nav.home}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 rounded-lg transition-colors"
            >
              {t.nav.about}
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 rounded-lg transition-colors"
            >
              {t.nav.services}
            </button>
            <button
              onClick={() => scrollToSection('why-us')}
              className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 rounded-lg transition-colors"
            >
              {t.nav.whyUs}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 rounded-lg transition-colors"
            >
              {t.nav.contact}
            </button>
            <Button
              onClick={() => scrollToSection('consultation')}
              className="w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white"
            >
              {t.nav.consultation}
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;